<template>
  <div class="studies-map">
    <header class="about-this-map-container">
      <ul>
        <router-link
          :to="{ name: ROUTE_NAMES.sources }"
          class="about-this-map-link"
          ><li>Sources</li></router-link
        >
      </ul>
    </header>
    <div class="table-buttons">
      <router-link :to="{ name: ROUTE_NAMES.table, params: { state: 'US' } }">
        <button class="table-button" id="all-studies-button">
          <md-icon class="md-size">table_chart</md-icon>All studies
        </button>
      </router-link>
      <router-link
        :to="{ name: ROUTE_NAMES.table, params: { state: 'unmapped' } }"
      >
        <button class="table-button">
          <md-icon class="md-size">table_chart</md-icon>Unmapped studies
        </button>
      </router-link>
    </div>
    <div v-if="studies.length > 0">
      <highcharts
        constructorType="mapChart"
        class="hc"
        :options="chartOptions"
        ref="chart"
      ></highcharts>
    </div>
    <div class="fixed-credits-container">
      <a href="http://zevross.com/" class="about-this-map-link"
        >Map application created by ZevRoss Spatial Analysis</a
      >
    </div>
  </div>
</template>

<script>
import router from "../router";
import { routerMixin } from "../router/router.mixin";
import unitedStatesJson from "../data/state.geo.json";
import shaleJson from "../data/shale.geo.json";
import sedimentJson from "../data/sediment.geo.json";

export default {
  name: "hei-studies-map",
  props: ["studies", "studiesByType"],
  mixins: [routerMixin],
  // methods: {
  //   downloadPDF(csv, filename) {
  //     let pdfFile;
  //     let downloadLink;
  //
  //     // CSV file
  //     pdfFile = new Blob([pdf], { type: "text/csv" });
  //
  //     // Download link
  //     downloadLink = document.createElement("a");
  //
  //     // File name
  //     downloadLink.download = filename;
  //
  //     // Create a link to the file
  //     downloadLink.href = window.URL.createObjectURL(pdfFile);
  //
  //     // Hide download link
  //     downloadLink.style.display = "none";
  //
  //     // Add the link to DOM
  //     document.body.appendChild(downloadLink);
  //
  //     // Click download link
  //     downloadLink.click();
  //   }
  // },
  data: function() {
    return {
      chartOptions: {
        title: {
          text: "",
        },
        chart: {
          backgroundColor: "#f8f1e6",
        },
        colorAxis: {
          min: 0,
          minColor: "#8fb8d1",
          maxColor: "#325672",
        },
        plotOptions: {
          series: {
            events: {
              click: function(e) {
                router.push(`/resources/table/${e.point["hc-key"]}`);
              },
            },
            states: {
              inactive: {
                opacity: 1,
              },
            },
          },
        },
        tooltip: {
          formatter() {
            let point = this;

            return `<b>${point.point.properties.state_name}</b> <br> <p>Total studies: ${point.point.value}</p>`;
          },
        },
        legend: {
          title: {
            text:
              'Total studies per state<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide shale/sedimentary layers)</span>',
          },
          align: "right",
          verticalAlign: "bottom",
          backgroundColor: "#fff",
          borderRadius: "4px",
          shadow: true,
          floating: true,
          width: 250,
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                mapNavigation: {
                  enabled: true,
                },
                series: [
                  {
                    dataLabels: {
                      allowOverlap: false,
                    },
                  },
                  {},
                  {},
                ],
              },
            },
          ],
        },
        series: [
          {
            cursor: "pointer",
            mapData: unitedStatesJson,
            name: "Total studies",
            dataLabels: {
              enabled: true,
              allowOverlap: true,
              format: "{point.properties.state_name}",
            },
            borderColor: "slategray",
            borderWidth: 1,
            data: [],
          },
          {
            mapData: sedimentJson,
            name: "Sedimentary basins",
            nullColor: "rgba(127, 191, 63, 0.5)",
            borderColor: "rgba(127, 191, 63, 1)",
            showInLegend: true,
            color: "rgba(127, 191, 63, 1)",
          },
          {
            mapData: shaleJson,
            name: "Shale plays",
            nullColor: "rgba(236, 236, 23, 0.5)",
            borderColor: "rgba(236, 236, 23, 1)",
            showInLegend: true,
            color: "rgba(236, 236, 23, 1)",
          },
        ],
      },
    };
  },
  watch: {
    studies() {
      this.chartOptions.series[0].data = this.studies;
    },
  },
};
</script>

<style lang="scss">
.studies-map {
  position: relative;
  background-color: #f8f1e6;
}
.table-buttons {
  z-index: 100;
  padding: 5px;
  position: absolute;
  display: flex;
  #all-studies-button {
    margin-right: 5px;
  }
  .table-button {
    display: flex !important;
    align-items: center !important;
    height: 100% !important;
    i {
      color: white !important;
      margin-right: 3px;
      font-size: 15px !important;
    }
  }
}

a:hover:not(.about-this-map-link) {
  text-decoration: none !important;
}

.highcharts-series-1,
.highcharts-series-2 {
  path {
    pointer-events: none;
  }
}

@media only screen and (min-width: 500px) {
  .table-buttons {
    top: 0;
    left: 0;
  }
}

@media only screen and (max-width: 500px) {
  .table-buttons {
    top: 25px;
    right: 0;
  }
}
</style>
